import ColumnDefinition from '../../../infrastructure/types/DataGrid/ColumnDefinition';
import React from 'react';
import typeHelper from '../../../infrastructure/helpers/common/typeHelper';
import InfoIcon from '../InfoIcon/InfoIcon';

function createHeaderCell<T>(column: ColumnDefinition<T>, i: number, createHeaderContent: (c: ColumnDefinition<T>) => JSX.Element): JSX.Element {
    if (column.info === undefined || column.info === null) {
        return (
            <div className='th' style={getHeaderCellStyle(column)} key={i}>

                {typeHelper.isFunction(createHeaderContent) ? createHeaderContent(column) : column.header}

            </div>
        );
    }
    else {
        return (
            <div className='th' style={getHeaderCellStyle(column)} key={i}>

                <InfoIcon info={column.info as string} isSmallSize={true} />{typeHelper.isFunction(createHeaderContent) ? createHeaderContent(column) : column.header}

            </div>
        );
    }
}

function createDataCell<T>(column: ColumnDefinition<T>, item: T, columnIndex: number, rowIndex: number): JSX.Element {
    return (
        <div key={columnIndex} className={`td ${column.className}`}>{column.getContent(item, rowIndex)}</div>
    );
}

function createDataRow<T>(columns: ColumnDefinition<T>[], item: T, i: number, getKey: (item: T, i: number) => string | number): JSX.Element {

    return (
        <div className='display-flex tr' key={getKey(item, i)}>
            {columns.map((column, j) => createDataCell(column, item, j, i))}
        </div>
    );
}

function getHeaderCellStyle<T>(column: ColumnDefinition<T>): React.CSSProperties {

    let style = {} as React.CSSProperties;

    if (typeHelper.isString(column.width)) {
        style.width = column.width;
    }

    return style;
}

export {
    createHeaderCell,
    createDataRow
};
